export default "/50f517735fec46580f19aae3e56e9fe21614ea75/8e8641da5546a83267ff7cb844712535.svg";